import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Eko Setiaji, RN.Dev',
    title: "Founder Ethan Shop",
    desciption:"Menyiapkan tujuan adalah langkah awal menyibak yang tak terlihat menjadi terlihat. >>>>Membangun Indonesia Maju>>>>bersama Ethan Shop Mobile App",
    image: 'https://firebasestorage.googleapis.com/v0/b/itenshop-eb709.appspot.com/o/ImageWebsitePortofolioEko%2FIMG_3098.webp?alt=media&token=05e6cc92-c87f-44da-9e98-4f2b394aacc2',
    resumePdf: resume
}
